import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../lib/user.service';
import { CtAuthenticationService } from '@ctsolution/ct-authentication'; // Importa il servizio di autenticazione
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SellerGuard implements CanActivate {
  constructor(private router: Router, private userService : UserService, private authService: CtAuthenticationService) {}
 
  async canActivate(): Promise<boolean> {
    const user =  this.authService.userValue;

    // Utente loggato
    if (user) {
        const isSeller = this.userService.roleChecker.is.seller();
        const hasPermission = await this.userService.checkPermission();

        if (isSeller && !hasPermission) {
            this.router.navigate(['/become-seller']);
            return false;
        }
        return true; // Utente loggato (potrebbe essere venditore con permessi o acquirente)
    } else {
        // Utente non loggato - permetti la visualizzazione
        return true;
    }
}
}
